const lang = require('lang.js');
const messages = require('../../../translation/messages');

const Lang = new lang({
  messages
});

module.exports = Lang;
